import { render, staticRenderFns } from "./latestBlock.vue?vue&type=template&id=0bea4b31&scoped=true&"
import script from "./latestBlock.vue?vue&type=script&lang=js&"
export * from "./latestBlock.vue?vue&type=script&lang=js&"
import style0 from "./latestBlock.vue?vue&type=style&index=0&id=0bea4b31&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea4b31",
  null
  
)

export default component.exports